import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { BrandCard, Brand } from '../components/BrandCard';
import { ArrowLeft, Plus, Filter } from 'lucide-react';
// Mock Data
const brands: Brand[] = [{
  id: '1',
  name: 'Nike',
  status: 'active',
  lastContact: '2 days ago',
  contactPerson: {
    name: 'John Smith',
    email: 'john@nike.com'
  }
}, {
  id: '2',
  name: 'Adidas',
  status: 'pending',
  lastContact: '1 week ago',
  contactPerson: {
    name: 'Sarah Johnson',
    email: 'sarah@adidas.com'
  }
}, {
  id: '3',
  name: 'Red Bull',
  status: 'active',
  lastContact: '3 days ago',
  contactPerson: {
    name: 'Mike Chen',
    email: 'mike@redbull.com'
  }
}, {
  id: '4',
  name: 'Samsung',
  status: 'inactive',
  lastContact: '2 months ago',
  contactPerson: {
    name: 'Lisa Park',
    email: 'lisa@samsung.com'
  }
}];
export function BrandsPage() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'active' | 'pending' | 'inactive'>('all');
  const filteredBrands = brands.filter(brand => filter === 'all' || brand.status === filter);
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-401">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-402">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-403">
          <div className="flex items-center" data-id="element-404">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/manager')} data-id="element-405">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-406" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-407">
              Brand Management
            </h1>
          </div>
          <Button variant="primary" size="sm" className="bg-blue-600 hover:bg-blue-700" data-id="element-408">
            <Plus className="h-4 w-4 mr-2" data-id="element-409" /> Add Brand
          </Button>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
          <div className="flex space-x-8 -mb-px" data-id="element-411">
            <button onClick={() => navigate('/manager')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-412">
              Overview
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-413">
              Brands
            </button>
            <button onClick={() => navigate('/manager/projects')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-414">
              Projects
            </button>
            <button onClick={() => navigate('/manager/platforms')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-415">
              Platforms
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-416">
        <div className="flex items-center justify-between mb-6" data-id="element-417">
          <div className="flex items-center space-x-2" data-id="element-418">
            <Button variant={filter === 'all' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('all')} data-id="element-419">
              All
            </Button>
            <Button variant={filter === 'active' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('active')} data-id="element-420">
              Active
            </Button>
            <Button variant={filter === 'pending' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('pending')} data-id="element-421">
              Pending
            </Button>
            <Button variant={filter === 'inactive' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('inactive')} data-id="element-422">
              Inactive
            </Button>
          </div>
          <div className="flex items-center text-sm text-gray-500" data-id="element-423">
            <Filter className="h-4 w-4 mr-2" data-id="element-424" /> {filteredBrands.length} Brands
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-425">
          {filteredBrands.map(brand => <BrandCard key={brand.id} brand={brand} data-id="element-426" />)}
        </div>
      </main>
    </div>;
}